// Modules
import { useState } from 'react';

import { useAppSelector } from '@global/store/hooks';
import { subscriptionSelector } from '@global/store/slices/subscription/selectors';

// Css and assets
import './style.scss';
import { ReactComponent as UserIcon } from '@assets/images/User.svg';

// Components
import { UserDropdown } from './components/UserDropdown';

// Utils
import { useAuth } from '@global/hooks/useAuth';
import {
  customParseJwt,
  getTokensFromCookies,
} from '@src/global/hooks/useAuth/utils';

function buildUserNameAbbre(name: string): string {
  if (!name) return '';
  const [firstName, lastName = ''] = name.split(' ');
  return firstName.substring(0, 1) + lastName.substring(0, 1);
}

function getCustomerNameFromCookie(): string {
  const { almToken } = getTokensFromCookies();
  const name = customParseJwt(almToken)?.name ?? '';
  return name;
}

export const MenuNavigation = () => {
  const { isLoggedIn } = useAuth();

  const { subscriptionsByUid } = useAppSelector(subscriptionSelector);

  const name = subscriptionsByUid[Object.keys(subscriptionsByUid)[0]]
    ?.billingInfo?.name?.length
    ? subscriptionsByUid[Object.keys(subscriptionsByUid)[0]].billingInfo.name
    : getCustomerNameFromCookie();

  const [menuOpen, setMenuOpen] = useState(false);

  const openMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <>
      <div className="nav-menu">
        <div className="link-icon account-icon">
          {isLoggedIn ? (
            <span className="user-icon">{buildUserNameAbbre(name)}</span>
          ) : (
            <UserIcon
              className="icon-svg"
              role="img"
              title="Account"
              aria-label="Account"
            />
          )}
          <UserDropdown />
        </div>
      </div>

      <div className="nav-menu__mobile-menu" onClick={openMenu}>
        <div className={menuOpen ? 'burger-menu open' : 'burger-menu'}>
          <span />
        </div>
      </div>

      <div className={menuOpen ? 'mobile-nav-menu open' : 'mobile-nav-menu'}>
        <div className="section-extra">
          <div className="section-user">
            <UserDropdown setMenuOpen={setMenuOpen} isMobile={true} />
          </div>
        </div>
      </div>
    </>
  );
};
